import { ChangeDetectionStrategy, Component, Injector, OnInit, inject, ViewEncapsulation } from '@angular/core';
import { TabsModuleBase } from '@fi-app/utilities/tabs/tabs-module-base';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { ObjectTypes } from '@fi-shared/types';
import { FiChecklistHelperService } from '@fi-shared/checklist/fi-checklist-helper.service';
import { FiChecklist2ReportHelperService } from '@fi-shared/checklist/fi-checklist2-report/services/fi-checklist2-report-helper.service';
import { takeUntil } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { ChecklistV2StatesService } from '@fi-app/checklist/checklist-v2/checklist-v2-states.service';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { FiChecklist2ScheduleFactoryService } from '@fi-app/shared/checklist/schedule/services/fi-checklist2-schedule-factory.service';
import { FiChecklist2ScheduleDialogService } from '@fi-app/shared/checklist/schedule/services/fi-checklist2-schedule-dialog.service';

@Component({
    selector: 'fi-checklist-v2-list-navigation-tabs',
    templateUrl: './checklist-v2-list-navigation-tabs.component.html',
    styleUrls: ['./checklist-v2-list-navigation-tabs.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-checklist-v2-list-navigation-tabs' },
    standalone: false,
})
export class ChecklistV2ListNavigationTabsComponent extends TabsModuleBase implements OnInit {
    FiStateNames = FiStateNames;
    isNavBarHidden$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private checklistV2StatesService = inject(ChecklistV2StatesService);
    private fiChecklistHelperService = inject(FiChecklistHelperService);
    private fiChecklist2ReportHelperService = inject(FiChecklist2ReportHelperService);
    private pageTitleService = inject(PageTitleService);
    private fiChecklist2ScheduleFactoryService = inject(FiChecklist2ScheduleFactoryService);
    private fiChecklist2ScheduleDialogService = inject(FiChecklist2ScheduleDialogService);

    constructor(injector: Injector) {
        super(injector);
    }

    ngOnInit() {
        this.tabs = this.checklistV2StatesService.getChecklistV2SettingsTabs();

        super.updateSelectedTabFromState();
        this.subscribeOnHideNavBar();
        this.pageTitleService.setTitleByItem(ObjectTypes.Checklist2);

        // todo for tests
        // this.fiChecklistHelperService.openAddChecklistDialog();
    }

    private subscribeOnHideNavBar() {
        this.fiChecklist2ReportHelperService
            .getPageNavBarVisibility$()
            .pipe(takeUntil(this.ngOnDestroy$))
            .subscribe((isHidden: boolean) => this.isNavBarHidden$.next(isHidden));
    }

    openAddDialog() {
        const sref = this.getAddSref();
        if (sref === FiStateNames.ChecklistV2.Add._name) {
            this.fiChecklistHelperService.openAddChecklistDialog();
        }
        if (sref === FiStateNames.ChecklistV2.Template.Add._name) {
            this.fiChecklistHelperService.openAddChecklistTemplateDialog();
        } else if (sref === FiStateNames.ChecklistV2.Schedule.Add) {
            this.fiChecklist2ScheduleDialogService.openAddChecklistScheduleDialog(
                this.fiChecklist2ScheduleFactoryService.getChecklistScheduleInstance(false),
                false,
            );
        }
    }

    openAddReportWidgetDialog() {
        this.fiChecklist2ReportHelperService.triggerAddNewWidgetOpenDialog();
    }

    showAddButton(): boolean {
        const addSref = this.getAddSref();
        return addSref && addSref !== FiStateNames.ChecklistV2.Report.Dashboard;
    }

    isReportState(): boolean {
        return this.getAddSref() === FiStateNames.ChecklistV2.Report.Dashboard;
    }

    get isAddNewWidgetButtonShown$() {
        return this.fiChecklist2ReportHelperService.isAddNewWidgetButtonShown$;
    }
}
